import { useParams } from 'react-router-dom';
import { useMyServices, serviceProviderScope } from '@/api/services';
import { VMWARE_SCOPE } from '@/api/vmware/_shared';
import { InstanceConsole as ComputeConsole } from './compute/instances/InstanceConsole';
import { InstanceConsole as VmwareConsole } from './vmware/instances/InstanceConsole';

/**
 * Full-window console popup dispatcher (`/services/compute/:serviceId/instances/:id/console`).
 *
 * The console mechanism differs by provider — mirroring @console's ManageConsole switch:
 *   - Internal.VMware  → WebMKS iframe (acquire_ticket → webconsole.html)
 *   - Internal.Opennebula → noVNC / Guacamole tunnel (the /vnc ticket)
 *
 * A single route served OpenNebula's console for everyone, so opening a VMware VM's
 * console called the wrong provider endpoint (s10003/vnc instead of s10006/acquire_ticket).
 * Resolve the service's scope from the already-fetched service list and pick the matching
 * console. While the list loads, render nothing (both consoles show their own spinner).
 */
export function ConsoleRouter() {
  const { serviceId } = useParams<{ serviceId: string }>();
  const { data: services = [] } = useMyServices();

  if (services.length === 0) return null;

  const svc = services.find((s) => s.id === serviceId);
  const scope = svc ? serviceProviderScope(svc) : '';
  return scope === VMWARE_SCOPE ? <VmwareConsole /> : <ComputeConsole />;
}

export default ConsoleRouter;
